export default __webpack_public_path__ + "static/media/image-chairsensor-w@2x.4a276ea7.png";